// extracted by mini-css-extract-plugin
export var active = "ourleadership-module--active--XkWx8";
export var buttons = "ourleadership-module--buttons--Z3nbu";
export var ourLeadership = "ourleadership-module--our-leadership--1BLtF";